import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  element: '.js-split-feature',
  content: '.js-split-feature-content'
}

class SplitFeature {
  constructor (element) {
    this.element = element
    this.content = this.element.querySelector(SELECTORS.content)
    this.firstMedia = this.element.querySelector('.unlocked-media')
    this.caption = this.firstMedia && this.firstMedia.querySelector('.media-caption')
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.init()
  }

  init() {
    this.setHeightVar()
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, () => this.setHeightVar())
  }

  setHeightVar() {
    let captionHeight = 0
    if (this.caption) {
      const style = getComputedStyle(this.caption)
      captionHeight += this.caption.offsetHeight
      captionHeight += parseInt(style.marginTop) || 0
    }
    this.element.style.setProperty('--caption-height', `${captionHeight}px`)

    this.element.style.setProperty('--feature-content-height', `${this.content.offsetHeight}px`)
  }
}

export default {
  selector: SELECTORS.element,
  Source: SplitFeature
}
